import { useEffect, useRef, useState } from 'react'
import Icon from '../../components/icons.jsx'
import { getOperacaoPerson } from '../../db/api.js'
import { loadPersonReportExport, downloadPersonReportCsv, printPersonReport } from '../../lib/personReportExport.js'

export default function PersonReportExport({ person, clientId, period, disabled }) {
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [notice, setNotice] = useState(null)
  const root = useRef(null), trigger = useRef(null), mounted = useRef(false)
  useEffect(() => { mounted.current = true; return () => { mounted.current = false } }, [])
  useEffect(() => {
    if (!open) return
    root.current?.querySelector('[role="menuitem"]')?.focus()
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open])
  const start = async format => {
    if (busy) return
    setOpen(false); setBusy(true); setNotice(null); trigger.current?.focus()
    try {
      const result = await loadPersonReportExport(getOperacaoPerson, person.id, { clientId, from: period.from, to: period.to }, () => mounted.current)
      if (!result) return
      if (format === 'csv') downloadPersonReportCsv(result)
      else printPersonReport(result, message => { if (mounted.current) setNotice({ error: true, text: message }) })
      setNotice({ text: format === 'csv' ? 'CSV preparado para abrir no Excel.' : 'Na impressão, escolha “Salvar como PDF”.' })
    } catch (error) { if (mounted.current) setNotice({ error: true, text: error.message || 'Não foi possível exportar. Tente novamente.' }) }
    finally { if (mounted.current) setBusy(false) }
  }
  return <div ref={root} className="oe-report-export" onKeyDown={event => {
    if (event.key === 'Escape' && (open || notice)) { event.stopPropagation(); setOpen(false); setNotice(null); trigger.current?.focus() }
    if (open && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
      event.preventDefault()
      const items = [...root.current.querySelectorAll('[role="menuitem"]')]
      const index = items.indexOf(document.activeElement)
      items[(index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length]?.focus()
    }
  }}>
    <button ref={trigger} type="button" className="oe-period-trigger" disabled={disabled || busy} aria-haspopup="menu" aria-expanded={open} onClick={() => { setNotice(null); setOpen(v => !v) }}><Icon n="download" s={14} />{busy ? 'Exportando…' : 'Exportar'}<Icon n="chevron_d" s={12}/></button>
    {open && <div className="oe-report-export-menu" role="menu" aria-label="Exportar relatório"><button type="button" role="menuitem" onClick={() => start('pdf')}>PDF <small>Gráficos, indicadores e histórico</small></button><button type="button" role="menuitem" onClick={() => start('csv')}>CSV / Excel <small>Indicadores, dados por dia e histórico</small></button></div>}
    {busy && <span className="oe-export-notice" role="status">Preparando todo o histórico do período…</span>}
    {notice && <div className="oe-export-notice" role={notice.error ? 'alert' : 'status'}>{notice.text}<button type="button" aria-label="Fechar aviso de exportação" onClick={() => setNotice(null)}><Icon n="x" s={12}/></button></div>}
  </div>
}
